import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 20,
    backgroundColor: theme.colors.dark.midnightBlue,
    borderRadius: 18,
    '& .AccordionContainer': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 18,
      borderBottomLeftRadius: 18,
      backgroundColor: theme.colors.dark.darkSlateBlue,
    },
    '& .MuiAccordionSummary-expandIcon': {
      flex: '50 0 auto',
      marginRight: 10,
      '& .MuiSvgIcon-root': {
        fontSize: 30,
        fill: 'white',
      },
    },
    '& .MuiAccordionDetails-root': {
      display: 'block',
    },
  },
  cardTop: {
    display: 'flex',
    padding: '10px 10px',
  },
  cardMiddle: {
    padding: '10px 10px',
  },
  orderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '50px',
    background: '#1b273c',
    borderBottomRightRadius: '10px',
    borderBottomLeftRadius: '10px',
  },
  ListPara: {
    color: theme.colors.light.lightCyan,
    fontSize: theme.fonts.sizes.font12PX,
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: 10,
  },
  cardInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '75%',
    paddingLeft: 10,
  },
  cardTitle: {
    marginBottom: 5,
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font16PX,
    color: theme.colors.light.lightSteelBlue,
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .EuroSign': {
      color: theme.colors.light.freshPowder,
      fontSize: theme.fonts.sizes.font14PX,
      position: 'absolute',
    },
  },
  cardImg: {
    maxWidth: '30%',
    objectFit: 'cover',
    borderRadius: 8,
  },
  cardBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 0',
    fontSize: theme.fonts.sizes.font14PX,
  },
  cardPriceLettering: {
    color: theme.colors.light.ghostWhite,
  },
  cardPriceNumber: {
    fontWeight: 500,
    fontSize: theme.fonts.sizes.font24PX,
    color: theme.colors.light.freshPowder,
  },
  ListWrapper: {
    marginBottom: 20,
  },
  ListHeading: {
    color: theme.colors.light.lightSteelBlue,
    fontSize: theme.fonts.sizes.font16PX,
    marginBottom: 10,
    fontWeight: 'bold',
  },
  DiscriptionWrapper: {
    marginBottom: 20,
  },
  DisHeading: {
    color: theme.colors.light.lightSteelBlue,
    fontSize: theme.fonts.sizes.font16PX,
    marginBottom: 10,
    fontWeight: 'bold',
  },
  DisPara: {
    color: theme.colors.light.lightCyan,
    fontSize: theme.fonts.sizes.font12PX,
    fontWeight: 'normal',
    lineHeight: 1.2,
    marginBottom: 20,
  },
  mainHeading: {
    color: theme.colors.light.lightSteelBlue,
    fontSize: theme.fonts.sizes.font16PX,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  List: {
    color: theme.colors.light.lightCyan,
    fontSize: theme.fonts.sizes.font12PX,
    marginRight: 5,
  },
  Wrapper: {
    display: 'flex',
  },
  delContainer: {
    background: theme.colors.dark.darkSlateBlue,
    height: 50,
    width: '100%',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 18,
    borderBottomLeftRadius: 18,
  },
  ImgWrapper: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 12,
  },
  ChipContainer: {
    overflow: 'auto',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiBackdrop-root': {
      background: 'rgba(2, 7, 20, 0.6) !important',
      backdropFilter: 'blur(5px) !important',
    },
  },
  paper: {
    background: theme.colors.dark.midnightBlue,
    width: 327,
    height: 202,
    padding: '10px 10px',
    border: 'none',
    boxShadow: '0px 8px 12px rgba(3, 6, 23, 0.5)',
    borderRadius: 18,
    '&:focus': {
      outline: 'none !important',
    },
  },
  delMessage: {
    color: theme.colors.light.freshPowder,
    fontSize: theme.fonts.sizes.font20PX,
    fontFamily: theme.fonts.family.primary,
    fontWeight: 900,
    textAlign: 'center',
    marginTop: 30,
    marginBottom: 20,
  },
  BtnContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}));

export const useStylesOrderButton = makeStyles(theme => ({
  root: {
    margin: '5px 5px 5px 11px',
    padding: '0 30px',
    color: theme.colors.light.freshPowder,
    fontSize: theme.fonts.sizes.font13PX,
    backgroundColor: theme.colors.orange.orange,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
      color: theme.colors.light.freshPowder,
    },
  },
}));

export const useStylesDetailsButton = makeStyles(theme => ({
  root: {
    margin: '5px 5px 5px 11px',
    padding: '0 30px',
    color: theme.colors.light.freshPowder,
    fontSize: theme.fonts.sizes.font13PX,
    backgroundColor: theme.colors.dark.darkBlue,
    '&:hover': {
      backgroundColor: theme.colors.dark.darkBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));

export const useStylesConfirmDeleteOrder = makeStyles(theme => ({
  root: {
    width: 138,
    height: 46,
    margin: '0px 10px',
    backgroundColor: theme.colors.orange.orange,
    color: theme.colors.light.freshPowder,
    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
      color: theme.colors.light.freshPowder,
    },
  },
}));

export const useStylesDeclineDeleteOrder = makeStyles(theme => ({
  root: {
    width: 138,
    height: 46,
    backgroundColor: theme.colors.dark.steelBlue,
    color: theme.colors.light.freshPowder,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));
